module.exports = __webpack_public_path__ + "img/addmember-icon.4f2405e6.svg";